export default class Localization {
    constructor(data) {
        this.detectedCulture = "";
        if (window && window.navigator) {
            this.detectedCulture = window.navigator.language;
        }
        this.data = data || {}; 
    }
    getResource(culture) {
        let resource = {};

        let lang = this.getLanguage(culture);

        //check if it has the support language and fallback 
        if (!this.data[lang]) {
            lang = "en";
        }

        //get resource
        if (this.data[lang]) {
            resource = this.data[lang];
        }
        return resource;
    }
    getLanguage(culture) {
        //default to detected language
        if (!culture) {
            culture = this.detectedCulture;
        }

        //default to english
        if (!culture) {
            culture = "en";
        }

        //extract language from culture
        let lang = culture.split("-")[0];

        return lang;
    }
    translate(phrase, culture) {
        let lang = this.getLanguage(culture);
        let translatedPhrase = phrase;
        let resource = this.data[lang];
        if (resource && resource[phrase]) {
            translatedPhrase = resource[phrase]
        }

        return translatedPhrase;
    }
}